module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section04_07_american-village-73a433d91132c3e9288db362d38471df.jpg";